import { LogoFastship, LogoStorezigzin, LogoZdelivery } from '@croquiscom-pvt/zds';
import { vars } from '@croquiscom-pvt/zds/dist/tokens';
import styled from '@emotion/styled';

import type { DeliveryDateData, ShippingBadgeData } from '../../../type/common.type';

interface ItemCardShippingProps {
  /** 배송 뱃지 데이터 목록 */
  badge: ShippingBadgeData;
  /** 배송일 데이터 */
  delivery_date: DeliveryDateData | null;
}

export const ItemCardShipping = ({ badge, delivery_date }: ItemCardShippingProps) => {
  return (
    <ShippingBadgeContainer>
      <Badge hide={badge.type === null}>
        {badge.type === 'store_zigzin' && <LogoStorezigzin width={67} height={11} />}
        {badge.type === 'zigzin' && <LogoZdelivery width={57} height={11} />}
        {badge.type === 'fast_shipping' && <LogoFastship width={57} height={11} />}
      </Badge>
      {delivery_date && (
        <DeliveryDate
          color_type={delivery_date.color_type}
          dangerouslySetInnerHTML={{ __html: delivery_date.content }}
        />
      )}
    </ShippingBadgeContainer>
  );
};

const ShippingBadgeContainer = styled.div`
  margin: 3px 0 0 0;
  display: flex;
  align-items: center;
`;

const Badge = styled.span<{ hide: boolean }>`
  margin: 0 3px 0 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  ${({ hide }) => hide && 'display: none;'}
`;

const DeliveryDate = styled.span<{ color_type: DeliveryDateData['color_type'] }>`
  font-size: 12px;
  font-weight: 400;
  color: ${vars.v3Color.gray500};
  ${({ color_type }) => {
    switch (color_type) {
      case 'zigzin':
        return `color: ${vars.color.purple400}`;
      case 'store_zigzin':
        return `color: ${vars.color.blue400}`;
      case 'fast_shipping':
        return `color: ${vars.color.blueGray400}`;
      default:
        return `color: ${vars.v3Color.gray500}`;
    }
  }};
`;
